// extracted by mini-css-extract-plugin
module.exports = {"nav":"singlepage_nav__1yULT","page_wrap":"singlepage_page_wrap__bvaaB"};